import { Header, EmailConfirmationForm } from 'widgets';
import { PageLayout } from 'shared/ui';

export const EmailConfirmationPage: React.FC = () => {
  return (
    <PageLayout>
      <Header />
      <EmailConfirmationForm />
    </PageLayout>
  );
};
